
import { ChangeDetectionStrategy, Component, effect, inject, input, output, viewChild } from '@angular/core';
import { ProjectTypeId } from '@app/shared/data/project-enums';
import { AgGridAngular } from 'ag-grid-angular';
import { FilterChangedEvent, SelectionChangedEvent } from 'ag-grid-community';
import { GeneralProjectService } from '../../services/general-project.service';
import { drillGroupMappingGridOptions } from './columns';

@Component({
  selector: 'app-project-drill-group-mapping',
  templateUrl: './project-drill-group-mapping.component.html',
  styleUrls: ['./project-drill-group-mapping.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    AgGridAngular,
  ],
})
export class ProjectDrillGroupMappingComponent {
  public generalProjectService = inject(GeneralProjectService);

  readonly projectTypeId = input<number>(undefined);
  readonly projectSubTypeId = input<number>(undefined);
  public ProjectTypeId = ProjectTypeId;
  readonly rowSelected = output<any>();

  public readonly drillGroupsSelectionGrid = viewChild<AgGridAngular>('drillGroupsSelectionGrid');

  public drillGroupMappingGridOptions = drillGroupMappingGridOptions;

  public selectedDrillGroup: any[] = [];
  public loading: boolean = false;
  private pendingDrillGroupRows: any[] | null = null;

  constructor() {
    effect(() => {
      const projectTypeId = this.projectTypeId();
      if (projectTypeId != this.ProjectTypeId.PadConstruction) {
        this.loadData(projectTypeId, null)
      }
    });
    effect(() => {
      const projectTypeId = this.projectTypeId();
      const projectSubTypeId = this.projectSubTypeId();
      if (projectTypeId == this.ProjectTypeId.PadConstruction) {
        this.loadData(projectTypeId, projectSubTypeId)
      }
    });
  }

  onGridReady(params) {
    params.api.sizeColumnsToFit();
    this.applyPendingDrillGroupRows();
  }

  onFilterChanged(event: FilterChangedEvent) {
    event.api.setGridOption('rowSelection', {
      mode: 'multiRow',
      headerCheckbox: true,
      selectAll: event.api.isAnyFilterPresent() ? 'filtered' : 'all',
    });
  }

  onSelectionChanged(event: SelectionChangedEvent) {
    this.rowSelected.emit(event);
  }

  public async loadData(projectTypeId: number, projectSubTypeId: number = null) {
    await this.generalProjectService.getDrillGroups(projectTypeId, projectSubTypeId).then((resp) => {
      this.pendingDrillGroupRows = resp;
      this.applyPendingDrillGroupRows();
    });
  }

  private applyPendingDrillGroupRows() {
    const drillGroupsSelectionGrid = this.drillGroupsSelectionGrid();
    if (drillGroupsSelectionGrid?.api == null || this.pendingDrillGroupRows == null) {
      return;
    }
    drillGroupsSelectionGrid.api.setGridOption('rowData', this.pendingDrillGroupRows);
    drillGroupsSelectionGrid.api.setGridOption('loading', false);
    this.pendingDrillGroupRows = null;
  }
}